import { Col, Row } from 'antd';
import React from 'react';

import PageHeader from '@/components/PageHeader';

import { OrderManagement } from './components/OrderManagement';

const EdutainmentOrderManagement = () => {
  return (
    <Row>
      <Col span={24}>
        <PageHeader
          title="育樂活動訂單管理"
          breadcrumbs={[
            {
              name: '育樂活動',
            },
            {
              name: '育樂活動訂單管理',
            },
          ]}
        />
        <OrderManagement />
      </Col>
    </Row>
  );
};

export default EdutainmentOrderManagement;
